var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_861_44491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3V7.5H5.75",
    stroke: "#8F90A6",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 15V10.5H13.25",
    stroke: "#8F90A6",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8675 6.75018C15.4871 5.67527 14.8407 4.71423 13.9884 3.95674C13.1361 3.19925 12.1059 2.67 10.9938 2.41837C9.88167 2.16674 8.72393 2.20093 7.62861 2.51776C6.53328 2.83458 5.53606 3.42371 4.73 4.23018L1.25 7.50018M17.75 10.5002L14.27 13.7702C13.4639 14.5766 12.4667 15.1658 11.3714 15.4826C10.2761 15.7994 9.11833 15.8336 8.00621 15.582C6.8941 15.3304 5.86385 14.8011 5.0116 14.0436C4.15935 13.2861 3.51288 12.3251 3.1325 11.2502",
    stroke: "#8F90A6",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_861_44491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/Restart.41b743172d176bd24533a639aa98117f.svg";
export { ForwardRef as ReactComponent };